import { Close } from '@mui/icons-material';
import { Box, FormLabel, IconButton } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { SelectTagField } from 'src/components';
import { RHFTextField } from 'src/components/minimals/form';
import { TagResponse } from 'src/types';

type Props = {
  tags: TagResponse[];
  index: number;
  onRemove: (index: number) => void;
  isMobile: boolean;
};

export const TagWithLabel = ({ tags, index, onRemove, isMobile }: Props) => {
  const { setValue } = useFormContext();

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '10px',
        alignItems: isMobile ? 'flex-start' : 'center',
        justifyContent: 'flex-start',
        flexDirection: isMobile ? 'column' : 'row',
        border: isMobile ? '1px solid grey' : 'none',
        padding: isMobile ? '10px' : 0,
        borderRadius: '8px',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: isMobile ? '100%' : undefined,
          order: isMobile ? 2 : 1,
        }}
      >
        <FormLabel sx={{ mb: 0.5, fontSize: '0.9rem' }}>Label</FormLabel>
        <RHFTextField
          size="small"
          name={`tags.${index}.label`}
          label={''}
          testId="tag-label"
          sx={{ maxWidth: isMobile ? '100%' : '150px' }}
        />
      </Box>

      <Box sx={{ flex: 1, width: isMobile ? '100%' : undefined, order: isMobile ? 3 : 2 }}>
        <FormLabel sx={{ mb: 0.5, fontSize: '0.9rem' }}>Value</FormLabel>
        <SelectTagField
          isAssetController
          labelRows
          size="small"
          name={`tags.${index}.id`}
          tags={tags ?? []}
          onChange={(event, newValue) => {
            const tag = tags.find((tag) => tag.id === newValue);
            setValue(`tags.${index}.label`, tag?.displayName);
            setValue(`tags.${index}.id`, tag?.id);
          }}
          label=""
        />
      </Box>
      <IconButton
        sx={{
          display: 'flex',
          order: isMobile ? 1 : 3,
          justifyContent: 'center',
          alignSelf: isMobile ? 'end' : 'center',
          alignItems: isMobile ? 'flex ' : 'center',
          mt: isMobile ? 0 : '20px',
          padding: '0',
        }}
        onClick={() => onRemove(index)}
      >
        <Close />
      </IconButton>
    </Box>
  );
};
